import React from 'react';
import { HOME } from '../Pages';

export default {
  path: HOME.pageURL,
  async action() {
    const { default: Home } = await import('./Home');
    return <Home key={'home'} />;
  },
};
